import React from 'react';
import { formatCurrency } from '../../lib/helpers/formatters';
import { ADMIN_TYPES } from '../../App';

const TotalTr = ({ totals = {}, profileType = '' }) => {
  const { cashed = 0, net = 0, iafTotal = 0 } = totals;

  return (
    <tr className="summary-tr">
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      {profileType === 'ASSOCIATION' && <td>-</td>}
      {profileType === 'ASSOCIATION' && <td>-</td>}
      {profileType === 'ASSOCIATION' && <td>-</td>}
      {ADMIN_TYPES.includes(profileType) && <td>-</td>}
      <td>{formatCurrency(net)}</td>
      <td>{formatCurrency(cashed)}</td>
      <td>-</td>
      {profileType !== 'UTILIZER' && <td>-</td>}
      {profileType !== 'UTILIZER' && <td>{formatCurrency(iafTotal)}</td>}
    </tr>
  );
};

export default TotalTr;
